import * as React from "react"
import type { SVGProps } from "react"
const SvgPiggyBank = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M5.93 21.43q-.58 0-1.12-.4t-.71-.98q-.63-2.1-1.02-3.63a53 53 0 0 1-.64-2.7 23 23 0 0 1-.34-2.07q-.1-.9-.1-1.72a5.3 5.3 0 0 1 1.6-3.9 5.3 5.3 0 0 1 3.9-1.6h5a5 5 0 0 1 1.71-1.45 5 5 0 0 1 2.29-.55q.63 0 1.06.44a1.5 1.5 0 0 1 .4 1.36q-.03.15-.09.27l-.18.55a4 4 0 0 0-.14.6l2.27 2.28H21q.42 0 .71.29.3.29.29.7v5.26a1 1 0 0 1-.19.57 1 1 0 0 1-.51.38l-2.12.7L17.93 20A2 2 0 0 1 16 21.43h-2q-.83 0-1.41-.59a2 2 0 0 1-.59-1.41h-2q0 .82-.59 1.41a2 2 0 0 1-1.41.59zm.07-2h2v-2h6v2h2l1.55-5.15 2.45-.83V9.93h-1l-3.5-3.5a7 7 0 0 1 .25-1.9 3 3 0 0 0-1.27.69q-.56.49-.8 1.21H7.5q-1.46 0-2.47 1.03A3.4 3.4 0 0 0 4 9.93q0 1.02.53 3.51A111 111 0 0 0 6 19.43m10-8q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3 1 1 0 0 0-.71.3 1 1 0 0 0-.29.7q0 .44.29.72.29.3.71.29m-4-2q.42 0 .71-.29a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.71 1 1 0 0 0-.71-.3H9a1 1 0 0 0-.71.3 1 1 0 0 0-.29.7q0 .44.29.72.29.3.71.29z" />
  </svg>
)
export default SvgPiggyBank
